export default "__VITE_ASSET__X3jZF4XN__"